export {default,getStaticProps} from "app/seo/presse/page";
